module.exports = __webpack_public_path__ + "img/logo-outline.59b6706b.png";